import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormMode, FormPageComponent } from '../../controls/components/template/form-page/form-page.component';
import { PageCommandComponent } from '../../controls/components/misc/page-command/page-command.component';
import { TextboxComponent } from '../../controls/components/basic/textbox/textbox.component';
import { LayoutColumnComponent } from '../../controls/components/basic/layout-column/layout-column.component';
import { LayoutRowComponent } from '../../controls/components/basic/layout-row/layout-row.component';
import { FormsModule, NgForm} from '@angular/forms';
import { PageCommandGroupComponent } from '../../controls/components/misc/page-command-group/page-command-group.component';

@Component({
  selector: 'app-form-page-test',
  standalone: true,
  imports: [FormPageComponent, PageCommandComponent, TextboxComponent, LayoutColumnComponent, LayoutRowComponent, FormsModule, PageCommandGroupComponent],
  templateUrl: './form-page-test.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './form-page-test.component.scss'
})
export class FormPageTestComponent implements OnInit {
  @ViewChild('tForm')
  private form: NgForm;
  
  mode: FormMode = FormMode.View;
  name: string = 'My name';

  ngOnInit() {
    setTimeout(() => this.form.form.disable());
  }

  onEditClick = (): void => {
    console.log('Edit clicked');
  }

  onSaveClick = (): void => {
    const formValue = this.form.form.value as { name: string };
    this.name = formValue.name;
    console.log('Save clicked');
  }

  onCancelClick = (): void => {
    this.form.form.reset({name: this.name});
    console.log('Cancel clicked');
  }

  onNewClick = (): void => {
    console.log('New clicked');
  }

  onCustomClick = (): void => {
    console.log('Custom clicked');
  }

  onModeChanged = (e: FormMode): void => {
    switch (e) {
      case FormMode.Edit:
        console.log('Edit mode');
        this.form?.form.enable();
        break;
      case FormMode.New:
        console.log('New mode');
        this.form?.form.reset();
        this.form?.form.enable();
        break;
      case FormMode.View:
        console.log('View mode');
        this.form?.form.disable();
    }
    this.mode = e;
  }

}
